import { useAlerts } from '../../context/AlertsContext';

export default function AlertBadge({ showCount = true }) {
  const { count } = useAlerts();

  if (!showCount || count === 0) return null;

  return (
    <span className="absolute -top-1 -right-1 flex h-5 min-w-[20px] items-center justify-center rounded-full bg-error-500 px-1 text-xs font-bold text-white">
      {count > 99 ? '99+' : count}
    </span>
  );
}
